import { useState } from "react";

/**
 * A picture drawn by the image model for the remake (mascots, Tadika categories): `/art/<id>.webp`.
 * Never an emoji. If a file is missing the tile shows the item's own first letter in a pastel block, so a card is never broken or empty.
 */
export function Art({ id, alt, className = "", label }: { id: string; alt: string; className?: string; label?: string }) {
  // webp when the picture was compressed, otherwise the original jpeg; only then the letter tile.
  const [step, setStep] = useState(0);
  const failed = step >= 2;
  if (failed) {
    return (
      <span role="img" aria-label={alt} className={`grid aspect-square place-items-center rounded-2xl bg-sky-100 text-3xl font-black text-sky-700 ${className}`}>
        {(label ?? alt).slice(0, 1).toUpperCase()}
      </span>
    );
  }
  return <img src={`/art/${id}.${step === 0 ? "webp" : "jpg"}`} alt={alt} loading="lazy" decoding="async" draggable={false} onError={() => setStep((n) => n + 1)} className={`select-none object-contain ${className}`} />;
}

/** Mascot pose; `duo-hello` is the welcome pair. Identity stays the same, pose and expression change by page. */
export function Mascot({ pose, className = "h-40 w-40" }: { pose: string; className?: string }) {
  return <Art id={`mascot/${pose}`} alt="" className={className} />;
}
